import { Loader, DateField, ModalHeader, ModalNext, ModalBody} from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import React, {
    useCallback,
    useContext,
    useEffect,
    useState,
} from 'react';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import metadata from './InstallmentsPopup.metadata.json5';
import styles from './InstallmentsPopup.module.scss';
import messages from './InstallmentsPopup.messages';

function InstallmentsPopup(props) {
    const {
        title,
        submissionVM,
        authHeader,
        rowData,
        isOpen,
        onResolve
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const [isLoading, setIsLoading] = useState(false);
    // const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const [installmentsData, setInstallmentsData] = useState();

    useEffect(() => {
        setIsLoading(true);

        const jobID = _.get(submissionVM, 'quoteID.value') || _.get(submissionVM, 'jobID.value');
        const installmentsCall = CustomQuoteService.retrieveInstallments(
            jobID,
            rowData.billingId,
            authHeader
        );

        installmentsCall.then((response) => {
            setInstallmentsData(response);
            setIsLoading(false);
        })
    }, []);

    const viewInstallmentDate = useCallback((item, index) => (
        <DateField
            id={`total${index}`}
            value={item.dueDate}
            readOnly
            hideLabel
            displayFormat="vshort"
        />
    ), []);

    const viewInstallmentAmount = useCallback((item, index) => (
        <CurrencyField
            id={`downPayment${index}`}
            value={item.amount}
            readOnly
            hideLabel
        />
    ), []);

    const onClickOk = useCallback(() => {
        onResolve()
    }, [onResolve]);

    const getHeader = useCallback(() => `${translator(messages.paymentPlan)}${rowData.name}`, 
    [rowData, translator])

    const overrideProps = {
        '@field': {
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        installmentsListTable: {
            visible: !_.isUndefined(installmentsData),
            data: installmentsData,
        },
        installmentsTableHeader: {
            content: getHeader()
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            viewInstallmentAmount,
            viewInstallmentDate,
            onClickOk
        },
        resolveClassNameMap: styles
    };

    return (
        <ModalNext isOpen={isOpen}>
            <ModalHeader title={title} />
            <ModalBody>
                <Loader loaded={!isLoading}>
                    <ViewModelForm
                        uiProps={metadata.componentContent}
                        model={installmentsData}
                        overrideProps={overrideProps}
                        classNameMap={resolvers.resolveClassNameMap}
                        callbackMap={resolvers.resolveCallbackMap}
                    />
                </Loader>
            </ModalBody>
        </ModalNext>
    )
}

InstallmentsPopup.propTypes = wizardProps;
export default InstallmentsPopup;
